import { CustomTargetModelData } from '../../../../model/custom-model/custom-target-model-data';
import { Dict } from '../../../../model/dict';
import { CUSTOM_MODEL_CCC_ID, CustomModelWithAbatementPerCcc } from './dashboard-calculation.service';
const areaToCcc = {
  persontransport: 'petrol_vehicles',
  godstransport: 'diesel_heavy_trucks',
  inrikes_sjofart: 'ship_freight',
  inrikesflyg: 'unspecified_emissions_from_aviation',
  jarn_och_stal: 'coal_usage_within_iron_and_steel_industries',
  raffinaderier: 'crude_oil_usage_within_petroleum_refinement',
  cement_och_mineral: 'cement_mineral_industries_coal_usage',
  kemi: 'coal_usage_within_chemical_industries',
  pappers_och_massa: 'coal_usage_within_pulp_paper_and_print_industries',
  metaller: 'prebaked_carbon_anodes_electrolysis_for_aluminium_production',
  ovrigt: 'industrial_unregulated_coal_use', //industri/ovrigt
  djurs_matsmaltning: 'unspecified_emissions_from_livestock',
  lagring_av_godsel: 'unspecified_emissions_from_manure_management',
  jordbruksmark: 'unspecified_emissions_from_aggregate_sources_and_non_co2_emission_sources_on_land',
  el_och_fjarrvarmeproduktion: 'electricity_use_non_specified_sources',
  lokal_uppvarmning: 'coal_use_non_specified_sources',
  arbetsmaskiner: 'mobile_machinery_diesel',
  losningsmedel_och_produktanvandning: 'unspecified_emissions_from_product_use',
  avfall: 'unspecified_emissions_from_disposal_of_solid_waste',
};

function getCccFromArea(area: keyof typeof areaToCcc): string {
  return areaToCcc[area];
}

const teToCcc: Dict<string> = {
  //persontransport
  increased_proportion_of_walking_and_cycling: getCccFromArea('persontransport'),
  transfer_from_car_to_railway: getCccFromArea('persontransport'),
  increased_proportion_of_non_travel_meetings_and_services: getCccFromArea('persontransport'),
  more_efficient_commuting_by_car: getCccFromArea('persontransport'),
  improved_vehicle_technology: getCccFromArea('persontransport'),
  increase_renewable_proportion_in_diesel: getCccFromArea('persontransport'),
  increase_renewable_proportion_in_petrol: getCccFromArea('persontransport'),
  shift_to_electric_vehicles: getCccFromArea('persontransport'),
  //godstransport
  transfer_from_heavy_truck_to_electric_railway: getCccFromArea('godstransport'),
  transfer_from_heavy_truck_to_sea: getCccFromArea('godstransport'),
  improved_load_factor_heavy_trucks: getCccFromArea('godstransport'),
  improved_vehicle_technology_heavy_trucks: getCccFromArea('godstransport'),
  biofuel_for_heavy_trucks: getCccFromArea('godstransport'),
  shift_to_electric_heavy_trucks: getCccFromArea('godstransport'),
  //inrikes_sjofart
  electrification_of_domestic_sea_freight_transport: getCccFromArea('inrikes_sjofart'),
  biofuels_for_sea_freight_transport: getCccFromArea('inrikes_sjofart'),
  more_efficient_sea_freight_transportation: getCccFromArea('inrikes_sjofart'),
  shift_to_lng_fuel_for_sea_freight_transportation: getCccFromArea('inrikes_sjofart'),
  //inrikesflyg
  biofuels_for_air_transport: getCccFromArea('inrikesflyg'),
  more_efficient_passenger_airplanes: getCccFromArea('inrikesflyg'),
  shift_from_passenger_air_transport_to_railway: getCccFromArea('inrikesflyg'),
  //jarn_och_stal
  production_using_hydrogen: getCccFromArea('jarn_och_stal'),
  biofuels_replacing_coal: getCccFromArea('jarn_och_stal'),
  electrification_of_production_in_iron_and_steel_industry: getCccFromArea('jarn_och_stal'),
  //cement_och_mineral
  ccs_for_cement_and_concrete_industry: getCccFromArea('cement_och_mineral'),
  electrification_of_production_in_cement_and_concrete_industry: getCccFromArea('cement_och_mineral'),
  biofuels_for_cement_and_mineral_industry: getCccFromArea('cement_och_mineral'),
  optimisation_of_concrete: getCccFromArea('cement_och_mineral'),
  low_carbon_construction_of_multi_family_residential_housing: getCccFromArea('cement_och_mineral'),
  low_carbon_construction_of_buildings: getCccFromArea('cement_och_mineral'),
  //raffinaderier
  renewable_raw_materials_for_refineries: getCccFromArea('raffinaderier'),
  ccs_ccu_for_refineries: getCccFromArea('raffinaderier'),
  renewable_hydrogen: getCccFromArea('raffinaderier'),
  //kemi
  renewable_raw_materials_for_chemical_industry: getCccFromArea('kemi'),
  increased_use_of_recycled_plastics: getCccFromArea('kemi'),
  ccs_ccu_for_chemical_industry: getCccFromArea('kemi'),
  //pappers_och_massa
  biofuels_for_paper_and_pulp_industry: getCccFromArea('pappers_och_massa'),
  electrification_of_production_in_paper_and_pulp_industry: getCccFromArea('pappers_och_massa'),
  //metaller
  biofuels_for_metal_industry: getCccFromArea('metaller'),
  //ovrigt(industri)
  biofuels_for_other_industry: getCccFromArea('ovrigt'),
  electrification_of_other_industries: getCccFromArea('ovrigt'),
  //jordbruksmark
  nitrification_reducers: getCccFromArea('jordbruksmark'),
  increased_effectiveness_by_plant_breeding_and_culturing: getCccFromArea('jordbruksmark'),
  rewetting: getCccFromArea('jordbruksmark'),
  optimising_fertiliser_use: getCccFromArea('jordbruksmark'),
  //djurs_matsmältning
  food_additives: getCccFromArea('djurs_matsmaltning'),
  changed_production: getCccFromArea('djurs_matsmaltning'),
  increased_resource_efficiency: getCccFromArea('djurs_matsmaltning'),
  //lagring_av_godsel
  reduce_evaporation_of_liquid_fertiliser: getCccFromArea('lagring_av_godsel'),
  fertiliser_from_an_aerobic_digestion_in_biogas_production: getCccFromArea('lagring_av_godsel'),
  //el_och_fjarrvarmeproduktion
  ccs_from_waste_incineration: getCccFromArea('el_och_fjarrvarmeproduktion'),
  shift_to_residual_heat_in_district_heating: getCccFromArea('el_och_fjarrvarmeproduktion'),
  reduced_proportion_of_fossil_waste: getCccFromArea('el_och_fjarrvarmeproduktion'),
  shift_to_biofuel_in_district_heating: getCccFromArea('el_och_fjarrvarmeproduktion'),
  replace_peat_with_biofuels: getCccFromArea('el_och_fjarrvarmeproduktion'),
  ccs_from_solid_biofuels_beccs: getCccFromArea('el_och_fjarrvarmeproduktion'),
  //lokal_uppvärmning
  heating_single_family_residential_buildings_with_renewable_solid_biofuels: getCccFromArea('lokal_uppvarmning'),
  heating_housing_and_buildings_with_renewable_solid_biofuels: getCccFromArea('lokal_uppvarmning'),
  heat_pumps_in_non_residential_commercial_buildings: getCccFromArea('lokal_uppvarmning'),
  shift_to_district_heating_in_buildings: getCccFromArea('lokal_uppvarmning'),
  shift_to_biogas_heating_of_non_residential_commercial_buildings: getCccFromArea('lokal_uppvarmning'),
  shift_to_district_heating_in_single_family_houses: getCccFromArea('lokal_uppvarmning'),
  //lösningmedel_och_produktanvändning
  replacement_of_fluorinated_gases: getCccFromArea('losningsmedel_och_produktanvandning'),
  destruction_of_fluorinated_gases: getCccFromArea('losningsmedel_och_produktanvandning'),
  replacing_solvents_with_alternatives: getCccFromArea('losningsmedel_och_produktanvandning'),
  reduced_use_of_solvents: getCccFromArea('losningsmedel_och_produktanvandning'),
  //arbetsmaskiner
  improved_energy_efficiency_and_hybridisation_of_mobile_machinery: getCccFromArea('arbetsmaskiner'),
  electrification_of_mobile_machinery: getCccFromArea('arbetsmaskiner'),
  mobile_machinery_using_biofuels: getCccFromArea('arbetsmaskiner'),
  //avfall
  reduced_leakage: getCccFromArea('avfall'),
  efficient_treatment_of_sewage_water_and_sludge: getCccFromArea('avfall'),
};

//ids. for custom models, dependent on board.
const customToCcc: Dict<string> = {
  // DEV - SE - /douglass/Copy of Panorama
  '6e9b884b-9354-4346-ac66-b2f667350547': getCccFromArea('persontransport'), // transport/persontransporter/transporteffektivt samhälle/kollektivtrafik
  '10546906-7461-4fc9-92f4-77fc44ef0f39': getCccFromArea('el_och_fjarrvarmeproduktion'), //Fossilfri elproduktion
  'a3bf2392-4a73-4b89-a7e3-dbfd95661412': getCccFromArea('metaller'), //Industri/Metalller/Fossilfri aluminiumproduktion
  // DEV - EN - /Panorama/Copy of Panorama
  '36ac4020-4ad5-4db8-8161-f2a23582a380': getCccFromArea('persontransport'), //Transport/Persontransporter/Transporteffektivt samhälle/kollektivtrafik
  '90278864-6bb5-4f17-8267-222747591a5a': getCccFromArea('el_och_fjarrvarmeproduktion'), //Fossilfri elproduktion
  '018a409b-09d5-406e-8c4c-1e9289fb844d': getCccFromArea('metaller'), //Industri/Metaller/Fossilfri aluminiumproduktion
  // PROD - EN - /COP Panorama/Copy of Panorama - eng
  'b76f1573-63a3-46d1-b4dd-55caa6845dbc': getCccFromArea('persontransport'), //Transport/Persontransporter/Transporteffektivt samhälle/kollektivtrafik
  'a20f9a37-174f-4eae-b3d6-c0deec281c13': getCccFromArea('el_och_fjarrvarmeproduktion'), //Energy/Power and heat production/Fossil free electricity production
  'aa6865d7-6469-4e78-baf8-d19555417868': getCccFromArea('metaller'), //Industry/Metals/Fossil-free aluminum production
  // PROD - PANORAMA - SE - /Panorama/Test av ny struktur i dashboard (SVE) Panorama - 9927548a-20ea-477b-980a-432052600059
  'cddae191-719f-44db-881c-f111caa2cb0d': getCccFromArea('persontransport'), // Kollektivtrafik
  'cd8b350c-2331-4e4d-a0fe-21434b74a8fe': getCccFromArea('el_och_fjarrvarmeproduktion'), // Fossilfri elproduktion
  '26a0c235-cb32-492b-bb56-184f1731af24': getCccFromArea('metaller'), // Fossilfri aluminiumproduktion
  // PROD - PANORAMA - EN - /Panorama/Test av ny struktur i dashboard (ENG) Panorama - 92b43704-9ca2-4dd5-9af8-253b1c041ef5
  'f3ec1bd5-7480-4aec-a2b3-7ce7429d6ac3': getCccFromArea('persontransport'), // Public transport
  '996ab307-b550-4a62-8075-df11892d4fc4': getCccFromArea('el_och_fjarrvarmeproduktion'), // Fossil-free electricity production
  '4ab76286-4c17-4404-8538-ead420b6599d': getCccFromArea('metaller'), // Fossil-free aluminum production
};

export function createGetCustomModelWithAbatementPerCccCopPanorama(idToTeLookup: Dict<string>) {
  return (
    customModelData: (CustomTargetModelData & { id: string })[],
    year: number
  ): CustomModelWithAbatementPerCcc[] => {
    return customModelData.map((cm) => {
      const teId = idToTeLookup[cm.id];
      const totalAbatement = cm.chartData.carbonAbatement[year] ?? 0;
      const ccc = teToCcc[teId] ?? customToCcc[teId] ?? CUSTOM_MODEL_CCC_ID;
      return {
        ...cm,
        cccAbatements: [{ ccc, abatement: totalAbatement }],
      };
    });
  };
}
